import { UserRole } from '../server-types';
export var AuthSteps;
(function (AuthSteps) {
    AuthSteps["CREDENTIAL_INPUT_SOCIAL"] = "CREDENTIAL_INPUT_SOCIAL";
    AuthSteps["LOADING"] = "LOADING";
    AuthSteps["CREDENTIAL_INPUT_TRADITIONAL"] = "CREDENTIAL_INPUT_TRADITIONAL";
    AuthSteps["TERMS_OF_SERVICE"] = "TERMS_OF_SERVICE";
    AuthSteps["CHOOSE_ROLE"] = "CHOOSE_ROLE";
    AuthSteps["ASK_WORK_EMAIL"] = "ASK_WORK_EMAIL";
    AuthSteps["CONFIRMATION_EMAIL_SENT"] = "CONFIRMATION_EMAIL_SENT";
    AuthSteps["CONFIRMATION_EMAIL_SENT_TEMPORARY_CONSUMER"] = "CONFIRMATION_EMAIL_SENT_TEMPORARY_CONSUMER";
    AuthSteps["SUCCESSFUL_REGISTRATION"] = "SUCCESSFUL_REGISTRATION";
    AuthSteps["MAIL_CONFIRMED_WAITING_REVIEW"] = "MAIL_CONFIRMED_WAITING_REVIEW";
    AuthSteps["VERIFY_LINK_EXPIRED"] = "VERIFY_LINK_EXPIRED";
    AuthSteps["UPGRADE_ROLE"] = "UPGRADE_ROLE";
    AuthSteps["DOWNGRADED_TO_CONSUMER"] = "DOWNGRADED_TO_CONSUMER";
    AuthSteps["CHOOSE_EMAIL_DOMAIN"] = "CHOOSE_EMAIL_DOMAIN";
    AuthSteps["SWITCH_TO_SOCIAL"] = "SWITCH_TO_SOCIAL";
    AuthSteps["REMIND_SOCIAL_ACCOUNT"] = "REMIND_SOCIAL_ACCOUNT";
})(AuthSteps || (AuthSteps = {}));
export var AuthErrors;
(function (AuthErrors) {
    AuthErrors["UPGRADING_WITH_NO_AUTH"] = "UPGRADING_WITH_NO_AUTH";
    AuthErrors["SERVER_ERROR"] = "SERVER_ERROR";
})(AuthErrors || (AuthErrors = {}));
export var responseIsSuccess = function (r) {
    return r && r.status && r.status >= 200 && r.status <= 299
        ? r.success === true
        : false;
};
export var responseIsError = function (r) {
    return r && r.status && r.status >= 400 && r.status <= 499
        ? r.success === false
        : false;
};
export var responseToPhase = function (r, socialInput, isLoading, upgradingRole, userLocalData, // TODO tipizzare i dati relativi all'utente salvati in LocalStorage
consumerCanRegister, forcedAskWorkEmail, sfContactId) {
    var _a, _b, _c, _d;
    var success = responseIsSuccess(r);
    var error = responseIsError(r);
    // in qualsiasi fase del processo, se sono in caricamento, mostro uno spinner
    if (isLoading) {
        return AuthSteps.LOADING;
    }
    if (upgradingRole && !r) {
        // sono nel caso in cui
        // TODO restituire errore in caso di upgradeRole con ruolo gia' proprio dell'utente
        if (!userLocalData) {
            return new Error(AuthErrors.UPGRADING_WITH_NO_AUTH);
        }
        else {
            return AuthSteps.UPGRADE_ROLE;
        }
    }
    else if ((r === undefined || r === null) && socialInput) {
        return AuthSteps.CREDENTIAL_INPUT_SOCIAL;
    }
    else if ((r === undefined || r === null) && !socialInput) {
        return AuthSteps.CREDENTIAL_INPUT_TRADITIONAL;
    }
    else if ((r === null || r === void 0 ? void 0 : r.key) === 'options.tosApproved') {
        return AuthSteps.TERMS_OF_SERVICE;
    }
    else if ((r === null || r === void 0 ? void 0 : r.key) === 'options.role') {
        return AuthSteps.CHOOSE_ROLE;
    }
    else if ((r === null || r === void 0 ? void 0 : r.key) === 'options.workEmail') {
        return AuthSteps.ASK_WORK_EMAIL;
    }
    else if ((r === null || r === void 0 ? void 0 : r.key) === 'options.workEmailVerifyToken') {
        return AuthSteps.VERIFY_LINK_EXPIRED;
    }
    else if (((_a = r === null || r === void 0 ? void 0 : r.userAuth) === null || _a === void 0 ? void 0 : _a.status) === 200 && r.userStatus === 'NOT_VERIFIED') {
        // nel caso la risposta sia sempre un "not verified" ma ci sia la variabile `forcedAskWorkEmail` impostata a true
        // significa che ho provato a loggarmi, non ero ancora verificato e ho premuto sul pulsante per cambiare
        // l'indirizzo email aziendale. Si tratta di stato interno, non dedotto dalle risposte del server
        if (forcedAskWorkEmail) {
            return AuthSteps.ASK_WORK_EMAIL;
        }
        else {
            return consumerCanRegister
                ? AuthSteps.CONFIRMATION_EMAIL_SENT_TEMPORARY_CONSUMER
                : AuthSteps.CONFIRMATION_EMAIL_SENT;
        }
    }
    else if (success && (r === null || r === void 0 ? void 0 : r.userStatus) === 'WAITING_REVIEW') {
        return AuthSteps.MAIL_CONFIRMED_WAITING_REVIEW;
    }
    else if (success && (r === null || r === void 0 ? void 0 : r.EmailDomainRow)) {
        // se ho `EmailDomainRow` significa che il server mi ha appena associato ad un emailDomain, quindi siamo nel caso
        // di una registrazione avvenuta con successo
        return AuthSteps.SUCCESSFUL_REGISTRATION;
    }
    else if (success &&
        ((_b = r === null || r === void 0 ? void 0 : r.userAuth) === null || _b === void 0 ? void 0 : _b.userSocialtype) === undefined &&
        ((_c = r === null || r === void 0 ? void 0 : r.userAuth) === null || _c === void 0 ? void 0 : _c.auth.user.role) !== UserRole.Internal) {
        // siamo nel caso di un login avvenuto con successo, in modo tradizionale, senza un account social associato
        return AuthSteps.SWITCH_TO_SOCIAL;
    }
    else if (success &&
        ((_d = r === null || r === void 0 ? void 0 : r.userAuth) === null || _d === void 0 ? void 0 : _d.userSocialtype) !== undefined &&
        r.authenticationMethod === 'EMAIL_PWD') {
        // siamo nel caso di un login avvenuto con successo, in modo tradizionale, e con un account social associato
        return AuthSteps.REMIND_SOCIAL_ACCOUNT;
    }
    else if (error &&
        (r === null || r === void 0 ? void 0 : r.key) === 'options.EmailDomain_id' &&
        r.type === 'EMPTY_NOT_ALLOWED' &&
        Array.isArray(r.choices)) {
        // siamo nel caso in cui un email domain ha piu' company associate, quindi devo scegliere
        return AuthSteps.CHOOSE_EMAIL_DOMAIN;
    }
    else if (error &&
        (r === null || r === void 0 ? void 0 : r.key) === 'options.authToken' &&
        r.type === 'INVALID_VALUE' &&
        !!sfContactId) {
        // siamo nel caso in cui un utente e' arrivato in un url con il token sfContactId presente ma ha gia' un bearer, che pero' e' scaduto
        // lo faccio tornare al login, come se fosse un rinnovo
        return socialInput
            ? AuthSteps.CREDENTIAL_INPUT_SOCIAL
            : AuthSteps.CREDENTIAL_INPUT_TRADITIONAL;
    }
    else {
        return new Error(AuthErrors.SERVER_ERROR);
    }
};
//# sourceMappingURL=steps.js.map